export default __webpack_public_path__ + "static/media/como-cadastrar-fundo.abffb522.svg";